import React from 'react';
import { connect } from 'react-redux';

import { entitySelectors } from '@store/entity/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';

import { SpaTreatmentsV2 } from './SpaTreatmentsV2';
import { SpaTreatmentsV2OwnProps, SpaTreatmentsV2StoreProps } from './SpaTreatmentsV2.types';

const mapStateToProps = (state): SpaTreatmentsV2StoreProps => ({
  property: entitySelectors.getProperty(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

export const SpaTreatmentsV2Connected: React.ComponentType<SpaTreatmentsV2OwnProps> =
  connect(mapStateToProps)(SpaTreatmentsV2);
